<div class="memberResources">
    <section class="page-container">
        <div class="container">
            <div class="row mb-4">
                <div class="col">
                    <h1 class="resourceName">Member Resources & Savings</h1>
                    <!-- <p class="">
                        Lucas ipsum info about what member resources are dolor sit amet moff skywalker ponda calamari amidala moff luke anakin tatooine antilles. Amidala skywalker calrissian gonk lars chewbacca.
                    </p> -->
                </div>
            </div>
            <div class="row mb-4 pb-4">
                <div class="col-12 mb-3">
                    <div class="searchCta mb-3">
                        Browse Member Resources
                    </div>
                    <div class="mainSearch">
                        <div class="searchContainer">
                            <div class="searchBox m-100">
                                <input type="search" class="form-control" [(ngModel)]="searchText" placeholder="search our member resources...">
                                <button type="button" class="btn btn-secondary m-100" (click)="searchResources()">Search</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <label for="timeRange" class="form-label">Category Filter</label>
                    <select (change)="searchResources()" class="form-select form-select-lg mb-3" aria-label="time select" [(ngModel)]="categorySearch">
                        <option value="-1" selected>All</option>
                        <option value="1">HR</option>
                        <option value="2">Legal</option>
                        <option value="3">Accounting</option>
                        <option value="4">Childcare</option>
                        <option value="5">Brokers</option>
                        <option value="6">Staffing</option>
                    </select>
                </div>
            </div>
            <hr />
            <div class="newsListWrap mt-4 row row-cols-1 row-cols-xl-3 row-cols-lg-2 row-cols-md-1 row-cols-sm-1 g-4">
                <div class="col" *ngFor="let page of resources">
                    <div class="articleCard card h-100" [routerLink]="['/public/resources/resource-page', page.pageId]">
                        <div class="articleImg" style="background-image: url({{page.mainImageUrl}});"></div>
                        <div class="articleTitle">
                            {{page.pageName}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>